// Domain access (RBAC) page (MIS-814 / Task 33).
//
// Thin route wrapper: renders the DomainAccessTable for the `:domainId` route
// param. All data fetching, grant/revoke mutations, and the success/error toasts
// live in the component.

import { createFileRoute, Link } from '@tanstack/react-router';
import { DomainAccessTable } from '@/components/access/DomainAccessTable';

export const Route = createFileRoute('/_authenticated/domains/$domainId/access')({
  component: DomainAccessPage,
});

function DomainAccessPage() {
  const { domainId } = Route.useParams();
  return (
    <div className="mx-auto max-w-3xl space-y-6 p-8">
      <div>
        <Link
          to="/domains/$domainId"
          params={{ domainId }}
          className="text-sm text-gray-500 hover:underline"
        >
          ← Domain
        </Link>
        <h1 className="mt-2 text-xl font-semibold text-gray-900">Domain access control</h1>
        <p className="text-sm text-gray-500">
          Manage who has access to this domain and their role.
        </p>
      </div>
      <DomainAccessTable domainId={Number(domainId)} />
    </div>
  );
}
